// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsZenConnectVideoRenderer_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8394 3.60648C12.3936 3.19437 12.7188 2.50638 12.6342 1.77115C12.5076 0.673861 11.5155 -0.113126 10.4183 0.0133388C9.32097 0.139926 8.53398 1.13199 8.66044 2.22928C8.74528 2.96488 9.21904 3.56095 9.85258 3.83597L10.1213 6.16544C9.27421 6.50614 8.57072 7.12833 8.12651 7.91617L3.99504 6.80924C3.81559 6.14249 3.29545 5.58707 2.58061 5.39566C1.51371 5.10977 0.417035 5.74283 0.131146 6.80973C-0.154743 7.87662 0.478436 8.9733 1.54533 9.25919C2.26066 9.45084 2.9893 9.2294 3.47807 8.74112L7.61345 9.84928L7.61332 9.87784C7.61332 10.6021 7.80583 11.2813 8.14238 11.8673L3.10222 16.1651C2.45121 15.9348 1.69865 16.0481 1.13554 16.5285C0.294964 17.245 0.194623 18.5075 0.911297 19.3479C1.62797 20.1884 2.89042 20.2887 3.73088 19.5722C4.29435 19.0916 4.52519 18.366 4.40019 17.6867L9.54326 13.3012C10.1471 13.6671 10.8556 13.8778 11.6133 13.8778C12.3147 13.8778 12.9739 13.6973 13.5472 13.3802L15.1182 15H17.9043L15.0007 12.0063C15.3888 11.3898 15.6133 10.6601 15.6133 9.87784C15.6133 9.51248 15.5644 9.1586 15.4727 8.82242L18.1967 6.56888C18.8439 6.8085 19.5977 6.70633 20.1679 6.23477C21.019 5.53067 21.1381 4.26993 20.434 3.41886C19.7299 2.56778 18.4693 2.44864 17.6181 3.15262C17.0474 3.62479 16.8058 4.34732 16.9209 5.02872L14.4583 7.06595C13.8416 6.44205 13.021 6.01993 12.1048 5.90775L11.8394 3.60648ZM11.6133 11.8778C12.7179 11.8778 13.6133 10.9825 13.6133 9.87784C13.6133 8.77323 12.7179 7.87784 11.6133 7.87784C10.5087 7.87784 9.61332 8.77323 9.61332 9.87784C9.61332 10.9825 10.5087 11.8778 11.6133 11.8778Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 16H10V24H20V16ZM12 20H16V22L12 22V20Z" class="svg-bg"/>
  <path d="M24 16L22 18V22L24 24V16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsZenConnectVideoRenderer is a generated icon component.
 */
let IconRmsZenConnectVideoRenderer = IconRmsZenConnectVideoRenderer_1 = class IconRmsZenConnectVideoRenderer extends IconBaseElement {
    render() {
        return html `${IconRmsZenConnectVideoRenderer_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsZenConnectVideoRenderer.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsZenConnectVideoRenderer = IconRmsZenConnectVideoRenderer_1 = __decorate([
    customElement('zui-icon-rms-zen-connect-video-renderer')
], IconRmsZenConnectVideoRenderer);
export { IconRmsZenConnectVideoRenderer };
